/* eslint-disable */
import ReactRouterPropTypes from 'react-router-prop-types';
import EntriesContextPropTypes from '../Contexts/Entries/Entries.props';
import ServicesContextPropTypes from '../Contexts/Services/Services.props';

const AppPropTypes = {
  /**
   * The current `entry`
   */
  entry: EntriesContextPropTypes.entry.isRequired,

  /**
   * The `history` props from `react-router`
   */
  history: ReactRouterPropTypes.history.isRequired,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,
};

export default AppPropTypes;
